import {ListColumnType, ListHeader} from "../../common/list/List.props";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.NORMAL,
        name: "분류",
        key: "type"
    },
    {
        type: ListColumnType.NORMAL,
        name: "회원명",
        key: "name"
    },
    {
        type: ListColumnType.NORMAL,
        name: "이메일",
        key: "email"
    },
    {
        type: ListColumnType.NORMAL,
        name: "회사명",
        key: "companyName"
    },
    {
        type: ListColumnType.NORMAL,
        name: "사업자 번호",
        key: "businessNumber"
    },
    {
        type: ListColumnType.NORMAL,
        name: "업태/업종",
        key: "companyType"
    },
    {
        type: ListColumnType.NORMAL,
        name: "보유 라이선스",
        key: "licenses"
    }
];